import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExerciseStatus, InscriptionStatus, InsuranceStatusCode, PublicMemberInfos, SpecialtyType } from '../store/public-member-search.model';

@Component({
    selector: 'odq-public-member-info',
    templateUrl: './public-member-info.component.html',
    styleUrls: ['./public-member-info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PublicMemberInfoComponent implements OnInit {

  @Input()
  memberPublicInfos: PublicMemberInfos

  @Input()
  specialtytypes: SpecialtyType[];

  @Input()
  insuranceStatusCodes: InsuranceStatusCode[];

  isNotAuthorized: boolean = false;

  today = new Date();

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
    this.isNotAuthorized = this.memberPublicInfos.effectiveInscriptionStatus === InscriptionStatus.NotRegistered ||
      (this.memberPublicInfos.effectiveExerciseStatus === ExerciseStatus.Inactive &&
        this.memberPublicInfos.effectiveInscriptionStatus === InscriptionStatus.Registered);
  }

  getInsuranceStatus(): string {
    const code = this.memberPublicInfos.effectiveInsuranceStatusCode;
    return this.insuranceStatusCodes?.find(isc => isc.code === code)?.description[this.translate.currentLang] || '';
  }

  getSpecialtyTypeLabelForId(id: string): string {
    return this.specialtytypes?.find(st => st.id === id)?.description[this.translate.currentLang] || '';
  }

  isActive(): boolean {
    return (
      this.memberPublicInfos.effectiveExerciseStatus === ExerciseStatus.Active &&
      this.memberPublicInfos.effectiveInscriptionStatus === InscriptionStatus.Registered
    );
  }

  isRegistered(): boolean {
    return (
      this.memberPublicInfos.effectiveInscriptionStatus === InscriptionStatus.Registered
    );
  }

  showMemberSpecification() {
    return this.isActive() && (this.memberPublicInfos?.isAnesthesiaHospital || this.memberPublicInfos?.isAnesthesiaPrivateClinic || this.memberPublicInfos?.isHomeVisit || this.memberPublicInfos?.isParticularMedicalCondition || this.memberPublicInfos?.isReducedMobility || this.memberPublicInfos?.isSleepApnea)
  }

  isPermitSuspended(): boolean {
    return this.memberPublicInfos?.permitType?.fr === 'Suspendu';
  }

  getSortedLimitations() {
    if (!this.memberPublicInfos?.limitations) {
      return [];
    }
    return [...this.memberPublicInfos.limitations].sort((a, b) => {
      const dateA = new Date(a.startAt);
      const dateB = new Date(b.startAt);
      return dateB.getTime() - dateA.getTime(); // Descending order
    });
  }
}
